namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class AttivazionePanel extends Serenity.PropertyPanel<AttivazioneRequest, any> {

        protected getFormKey() { return AttivazioneForm.formKey; }

        private form: AttivazioneForm;

        constructor(container: JQuery) {
            super(container);

            this.form = new AttivazioneForm(this.idPrefix);

            this.form.NewPassword.addValidationRule(this.uniqueName, e => {
                if (this.form.w('NewPassword', Serenity.PasswordEditor).value.length < 8) {
                    return "La password deve avere lunghezza di almeno 8 caratteri!";
                }
            });

            this.form.ConfirmPassword.addValidationRule(this.uniqueName, e => {
                if (this.form.ConfirmPassword.value !== this.form.NewPassword.value) {
                    return "Le password digitate non sono uguali!";
                }
            });

            this.byId('SubmitButton').click(e => {
                e.preventDefault();

                if (!this.validateForm()) {
                    return;
                }

                var request = this.getSaveEntity();
                Q.serviceCall({
                    url: Q.resolveUrl('~/Attivazione/ImpostaPassword'),
                    request: request,
                    onSuccess: response => {
                        Q.information("La tua password è stata registrata.", () => {
                            window.location.href = Q.resolveUrl('~/');
                        });
                    }
                });
            });
        }

        getTemplate() {
            return `
<div class="s-Panel p-4">
    <h5 class="text-center my-4">Completa la tua registrazione</h5>
    <form id="~_Form" action="">
        <div id="~_PropertyGrid"></div>
        <div class="px-field mt-4">
            <button id="~_SubmitButton" type="submit" class="btn btn-primary w-100">
                Imposta la tua password
            </button>
        </div>
    </form>
</div>`;
        }
    }
}